import { Routes, Route } from 'react-router-dom';
import RouteWrapper from '@/utils/RouteWrapper';
import buildRoutes from './buildRoutes';
import dashboardRoutes from './dashboardRoutes';
import settingRoutes from './settingRoutes';
import proposalRoutes from './proposalRoutes';
import paymentReminderRoutes from './paymentReminderRoutes';
import btsRoutes from './btsRoutes';
import salesRepRoutes from './salesRepRoutes';
import inventoryRoutes from './inventoryRoutes';
import userRoutes from './userRoutes';
import NotAuthorized from '@/components/ui/NotAuthorized';
import UnderDev from '@/components/ui/UnderDev';
import Login from '@/pages/login/Login';
import ResetPassword from '@/pages/user-setting/ResetPassword';
import NewUserActivationScreen from '@/pages/user-setting/NewUserActivationScreen';
import Layout from '@/Layout';

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/login"
        element={<RouteWrapper element={<Login />} isPrivate={false} />}
      />
      <Route
        path="/reset-password/:token"
        element={<RouteWrapper element={<ResetPassword />} isPrivate={false} />}
      />
      <Route
        path="/user-activation/:token"
        element={
          <RouteWrapper
            element={<NewUserActivationScreen />}
            isPrivate={false}
          />
        }
      />
      <Route
        path="/not-authorized"
        element={<RouteWrapper element={<NotAuthorized />} isPrivate={false} />}
      />

      {/* Main App Layout */}
      <Route path="/" element={<RouteWrapper element={<Layout />} />}>
        {buildRoutes(dashboardRoutes)}
        {buildRoutes(settingRoutes)}
        {buildRoutes(proposalRoutes)}
        {buildRoutes(paymentReminderRoutes)}
        {buildRoutes(btsRoutes)}
        {buildRoutes(salesRepRoutes)}
        {buildRoutes(inventoryRoutes)}
        {buildRoutes(userRoutes)}
        <Route path="*" element={<UnderDev />} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
